export default __webpack_public_path__ + "static/adult-day-care_testimonial-cc871474eac017b4ffd8e512fd675c02.jpg";